/* eslint-disable */
const web3Factory = require('./web3Helper');
const surveyAbi = require('../lib/contracts/Survey.json').abi;
const tokenAbi = require('../lib/contracts/AHTToken.json').abi;
const EthereumTx = require('ethereumjs-tx').Transaction;
import TrezorConnect from 'trezor-connect';

async function getSurveyActive() {
    let web3 = web3Factory.getInstance();
    let contractAddress = process.env.VUE_APP_SURVEY_ADDRESS
    
    let contract = new web3.eth.Contract(surveyAbi, contractAddress)

    return new Promise((resolve, reject) => {
        contract.methods.getSurveyActive().call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)  
        })
    })
}

async function getSurveyOptions(txData) {
    let web3 = web3Factory.getInstance();
    
    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress)

    return new Promise((resolve, reject) => {
        contract.methods.getSurvey(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)  
        })
    })
}

async function getBalance(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})
    
    return new Promise((resolve, reject) => {
        contract.methods.getBalance().call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function getAmountStakedByUser(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    return new Promise((resolve, reject) => {
        contract.methods.getAmountStaked().call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function getAmountStaked(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress)

    return new Promise((resolve, reject) => {
        contract.methods.getTotalAmountStacked().call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function getRewardPool(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress)

    return new Promise((resolve, reject) => {
        contract.methods.getSurveyRewardPool(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function getStakingHistory(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress)

    return new Promise((resolve, reject) => {
        contract.methods.getSurveyStakingHistory(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function saveAnswer (txData) {
    let web3 = web3Factory.getInstance();

    web3.eth.getTransactionReceiptMined = require('./getTransactionReceiptMined.js')
    
    let today = new Date();
    let dateVoted = parseInt((today.getTime() / 1000).toFixed(0))

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    let transactionParameters = {
        to: txData.contractAddress,
        from: txData.address,
        data: contract.methods.saveAnswer(
            txData.surveyName,
            txData.option,
            txData.typeVote,
            txData.typeReward,
            dateVoted
        ).encodeABI()
    }
    switch (txData.wallet) {
        case 0: 
            const txHash = await ethereum.request({
                method: 'eth_sendTransaction',
                params: [transactionParameters]
            });

            await web3.eth.getTransactionReceiptMined(txHash)
        break;
        case 1:
            let gasPrice = await web3.eth.getGasPrice()
            let nonce = await web3.eth.getTransactionCount(transactionParameters.from, "pending")

            transactionParameters.gasPrice = web3.utils.toHex(gasPrice)
            transactionParameters.nonce = web3.utils.toHex(nonce)
            
            let block = await web3.eth.getBlock("latest")
            let gasLimit = block.gasLimit
    
            transactionParameters.gasLimit = web3.utils.toHex(gasLimit)
            transactionParameters.value = web3.utils.toHex(web3.utils.toWei("0", "ether"))

            let result = await TrezorConnect.ethereumSignTransaction({
                path: "m/44'/60'/0'",
                transaction: transactionParameters
            })

            if(result.success) {
                transactionParameters.v = result.payload.v
                transactionParameters.r = result.payload.r
                transactionParameters.s = result.payload.s
            }

            let ethtx = new EthereumTx(transactionParameters);
            const serializedTx = ethtx.serialize();
            const rawTx = '0x' + serializedTx.toString('hex');

            await web3.eth.sendSignedTransaction(rawTx);
        break;
    }

    
}

async function sendStake (txData) {
    let web3 = web3Factory.getInstance();
    let today = new Date();
    let stakeStartDate = parseInt((today.getTime() / 1000).toFixed(0)) 

    web3.eth.getTransactionReceiptMined = require('./getTransactionReceiptMined.js')
    
    const amountStake = web3.utils.toWei(txData.amountStake)

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    let transactionParameters = {
        to: txData.contractAddress,
        from: txData.address,
        gasPrice: web3.utils.toWei('1', 'gwei'),
        gas: web3.utils.toHex(2000000),
        data: contract.methods.sendStake(
            txData.surveyName,
            amountStake,
            stakeStartDate
        ).encodeABI()
    }

    switch (txData.wallet) {
        case 0:
            const txHash = await ethereum.request({
                method: 'eth_sendTransaction',
                params: [transactionParameters]
            });

            await web3.eth.getTransactionReceiptMined(txHash)
        break;
        case 1:
            let gasPrice = await web3.eth.getGasPrice()
            let nonce = await web3.eth.getTransactionCount(transactionParameters.from, "pending")
            
            transactionParameters.gasPrice = web3.utils.toHex(gasPrice)
            transactionParameters.nonce = web3.utils.toHex(nonce)

            let block = await web3.eth.getBlock("latest")
            let gasLimit = block.gasLimit
            
            transactionParameters.gasLimit = web3.utils.toHex(gasLimit)
            transactionParameters.value = web3.utils.toHex(web3.utils.toWei("0", "ether"))

            let result = await TrezorConnect.ethereumSignTransaction({
                path: "m/44'/60'/0'",
                transaction: transactionParameters
            })

            if(result.success) {
                transactionParameters.v = result.payload.v
                transactionParameters.r = result.payload.r
                transactionParameters.s = result.payload.s
            }

            let ethtx = new EthereumTx(transactionParameters);
            const serializedTx = ethtx.serialize();
            const rawTx = '0x' + serializedTx.toString('hex');
            
            await web3.eth.sendSignedTransaction(rawTx);
        break;
    }

    
}

async function approve (txData) {
    let web3 = web3Factory.getInstance();

    web3.eth.getTransactionReceiptMined = require('./getTransactionReceiptMined.js')

    let amount = txData.amount ? txData.amount : 1;

    const calculatedApproveValue = web3.utils.toWei(amount);

    let contract = new web3.eth.Contract(tokenAbi, txData.contractAddress, { from: txData.address})

    let transactionParameters = {
        to: txData.contractAddress,
        from: txData.address,
        gasPrice: web3.utils.toWei('1', 'gwei'),
        gas: web3.utils.toHex(2000000),
        data: contract.methods.approve(
            txData.surveyAddress,
            calculatedApproveValue
        ).encodeABI()
    }

    switch (txData.wallet) {
        case 0:
            const txHash = await ethereum.request({
                method: 'eth_sendTransaction',
                params: [transactionParameters]
            });

            await web3.eth.getTransactionReceiptMined(txHash)
        break;
        case 1:
            let gasPrice = await web3.eth.getGasPrice()
            let nonce = await web3.eth.getTransactionCount(transactionParameters.from, "pending")

            transactionParameters.gasPrice = web3.utils.toHex(gasPrice)
            transactionParameters.nonce = web3.utils.toHex(nonce)
            
            let block = await web3.eth.getBlock("latest")
            let gasLimit = block.gasLimit
    
            transactionParameters.gasLimit = web3.utils.toHex(gasLimit)
            transactionParameters.value = web3.utils.toHex(web3.utils.toWei("0", "ether"))
            
            let result = await TrezorConnect.ethereumSignTransaction({
                path: "m/44'/60'/0'",
                transaction: transactionParameters
            })

            if(result.success) {
                transactionParameters.v = result.payload.v
                transactionParameters.r = result.payload.r
                transactionParameters.s = result.payload.s
            }

            let ethtx = new EthereumTx(transactionParameters);
            const serializedTx = ethtx.serialize();
            const rawTx = '0x' + serializedTx.toString('hex');

            let txR = await web3.eth.sendSignedTransaction(rawTx);

            await web3.eth.getTransactionReceiptMined(txR.transactionHash)
        break;
    }
    
    
    
}

async function stopStake(txData) {
    let web3 = web3Factory.getInstance();
    let today = new Date();
    let dateStop = parseInt((today.getTime() / 1000).toFixed(0));

    web3.eth.getTransactionReceiptMined = require('./getTransactionReceiptMined.js')

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    let transactionParameters = {
        to: txData.contractAddress,
        from: txData.address,
        gasPrice: web3.utils.toWei('1', 'gwei'),
        gas: web3.utils.toHex(2000000),
        data: contract.methods.stopStake(
            txData.surveyName,
            dateStop
        ).encodeABI()
    }

    switch (txData.wallet) {
        case 0:
            const txHash = await ethereum.request({
                method: 'eth_sendTransaction',
                params: [transactionParameters]
            })

            await web3.eth.getTransactionReceiptMined(txHash)
        break;
        case 1:
            let gasPrice = await web3.eth.getGasPrice()
            let nonce = await web3.eth.getTransactionCount(transactionParameters.from, "pending")
            
            transactionParameters.gasPrice = web3.utils.toHex(gasPrice)
            transactionParameters.nonce = web3.utils.toHex(nonce)

            let block = await web3.eth.getBlock("latest")
            let gasLimit = block.gasLimit

            transactionParameters.gasLimit = web3.utils.toHex(gasLimit)
            transactionParameters.value = web3.utils.toHex(web3.utils.toWei("0", "ether"))
            
            let result = await TrezorConnect.ethereumSignTransaction({
                path: "m/44'/60'/0'",
                transaction: transactionParameters
            })

            if(result.success) {
                transactionParameters.v = result.payload.v
                transactionParameters.r = result.payload.r
                transactionParameters.s = result.payload.s
            }

            let ethtx = new EthereumTx(transactionParameters);
            const serializedTx = ethtx.serialize();
            const rawTx = '0x' + serializedTx.toString('hex');

            await web3.eth.sendSignedTransaction(rawTx);
        break;
    }
}

async function getVotedOptions(txData) {
    let web3 = web3Factory.getInstance();
    
    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    return new Promise((resolve, reject) => { 
        contract.methods.getVotedOptions(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)  
        })
    })
}

async function getStakingInfo(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    return new Promise((resolve, reject) => {
        contract.methods.getStakingInfo(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function getVoteInfo(txData) {
    let web3 = web3Factory.getInstance();

    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress, { from: txData.address})

    return new Promise((resolve, reject) => {
        contract.methods.getVoteInfo(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)
        })
    })
}

async function getSurveyResult(txData) {
    let web3 = web3Factory.getInstance()
    
    let contract = new web3.eth.Contract(surveyAbi, txData.contractAddress)

    return new Promise((resolve, reject) => { 
        contract.methods.getSurveyResult(txData.surveyName).call(function (error, result) {
            if(!error)
                resolve({result})
            else
                reject(error.code)  
        })
    })
}

export {
    getSurveyOptions,
    getAmountStaked,
    getRewardPool,
    getStakingHistory,
    getBalance,
    getAmountStakedByUser,
    saveAnswer,
    sendStake,
    approve,
    stopStake,
    getVotedOptions,
    getStakingInfo,
    getVoteInfo,
    getSurveyResult,
    getSurveyActive
}